const KSIZE_MAPPER = {
    xs: 20,
    s: 32,
    m: 48,
    l: 96,
    xl: 156
};
const KAVATAR_SIZE_CLASSES = {
    xs: 'tw-w-2 tw-h-2',
    s: 'tw-w-3.2 tw-h-3.2',
    m: 'tw-w-4.8 tw-h-4.8',
    l: 'tw-w-9.6 tw-h-9.6',
    xl: 'tw-w-[15.6rem] tw-h-[15.6rem]'
};
const KSTATUS_CIRCLE_SIZE_CLASSES = {
    s: 'tw-bottom-[0.1rem] tw-right-[0.1rem] tw-h-0.8 tw-w-0.8 tw-border-[0.1rem]',
    m: 'tw-bottom-[0.2rem] tw-right-[0.2rem] tw-h-1.2 tw-w-1.2 tw-border-[0.2rem]',
    l: 'tw-bottom-0.4 tw-right-0.4 tw-h-2.4 tw-w-2.4 tw-border-0.4',
    xl: 'tw-bottom-0.8 tw-right-0.8 tw-h-3.2 tw-w-3.2 tw-border-0.4'
};
const KDEFAULT_AVATAR_URL = 'https://crehana-vercel-images-prd.imgix.net/public';
const KDEFAULT_AVATAR_PATH = {
    blue: '/7ff7eefa-d352-4088-bc63-67359a0fa1dd-avatar-default-blue.png',
    green: '/9c3d0306-3de5-4789-adb9-a6017ab7e94f-avatar-default-green.png',
    purple: '/ca166738-392d-4b34-8c28-9f7cf9251fc8-avatar-default-purple.png',
    red: '/92408a47-8b9e-4b2a-96ec-2d85ba0a15f9-avatar-default-red.png',
    violet: '/f2da02ea-9dc8-4411-aafe-9597e785e91e-avatar-default-violet.png',
    yellow: '/401c064a-8cd2-49f8-b569-901542b112e7-avatar-default-yellow.png'
};
export { KAVATAR_SIZE_CLASSES, KDEFAULT_AVATAR_PATH, KDEFAULT_AVATAR_URL, KSIZE_MAPPER, KSTATUS_CIRCLE_SIZE_CLASSES };
